import { useEffect, useRef, useState } from "react";

export default function Typewriter({ text = "", speed = 30, onDone }) {
  const [out, setOut] = useState("");
  const idxRef = useRef(0);
  const timerRef = useRef(null);
  const onDoneRef = useRef(onDone);

  useEffect(() => { onDoneRef.current = onDone; }, [onDone]);

  useEffect(() => {
    setOut("");
    idxRef.current = 0;

    const tick = () => {
      const i = idxRef.current;
      if (i < text.length) {
        setOut(prev => prev + text.charAt(i));
        idxRef.current = i + 1;
        timerRef.current = setTimeout(tick, speed);
      } else {
        onDoneRef.current && onDoneRef.current();
      }
    };

    timerRef.current = setTimeout(tick, speed);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [text, speed]);

  return (
    <p className="whitespace-pre-wrap leading-relaxed">
      {out}
    </p>
  );
}
